import { supabase } from '@/lib/supabase'
import type { Tables } from '@/types/database.types'

export type Day = Tables<'days'>

export async function listDays(tripId: string): Promise<Day[]> {
  const { data, error } = await supabase
    .from('days')
    .select('*')
    .eq('trip_id', tripId)
    .order('date')
  if (error) throw error
  return data
}

function addOneDay(date: string): string {
  const next = new Date(`${date}T00:00:00Z`)
  next.setUTCDate(next.getUTCDate() + 1)
  return next.toISOString().slice(0, 10)
}

export async function addNextDay(tripId: string): Promise<Day> {
  const days = await listDays(tripId)
  const lastDate = days.at(-1)?.date
  const nextDate = lastDate ? addOneDay(lastDate) : new Date().toISOString().slice(0, 10)

  const { data, error } = await supabase
    .from('days')
    .insert({ trip_id: tripId, date: nextDate })
    .select()
    .single()
  if (error) throw error
  return data
}

export class DayDeletionNotAllowedError extends Error {
  constructor() {
    super('Only the first or last day of the trip can be deleted.')
    this.name = 'DayDeletionNotAllowedError'
  }
}

export async function deleteDay(tripId: string, dayId: string): Promise<void> {
  const days = await listDays(tripId)
  const first = days[0]
  const last = days.at(-1)
  if (dayId !== first?.id && dayId !== last?.id) {
    throw new DayDeletionNotAllowedError()
  }

  const { error: unassignError } = await supabase
    .from('activities')
    .update({ day_id: null })
    .eq('day_id', dayId)
  if (unassignError) throw unassignError

  const { error } = await supabase.from('days').delete().eq('id', dayId)
  if (error) throw error
}
